<template>
  <v-dialog
    v-model="displayDialog"
    :width="!$vuetify.breakpoint.xs ? 500 : null"
    content-class="rounded-lg elevation-0"
    persistent
    class="security-authentication-dialog"
  >
    <PasswordChecking
      :loading="performingMutation"
      @recoverPassword="currentSlide = 'RECOVER_PASSWORD'"
      @closeDialog="closeDialog"
      @setPasswordAuthorization="setPasswordAuthorization"
      v-if="currentSlide === 'CHECK_PASSWORD' && requestPassword"
    />

    <PasswordRecovering
      @closeDialog="closeDialog"
      @recoverSuccess="currentSlide = 'RECOVER_SUCCESS'"
      @goBackStep="goBackStep()"
      v-if="currentSlide === 'RECOVER_PASSWORD'"
    />

    <PasswordRecovered
      @resetSteps="slides = ['CHECK_PASSWORD']"
      v-if="currentSlide === 'RECOVER_SUCCESS'"
    />

    <TwoFactor
      :requestPassword="requestPassword"
      :authenticationErrors="authenticationErrors"
      :loading="performingMutation"
      :declineText="$i18n.t('base.cancel')"
      @afterOnDecline="closeDialog"
      @setTFAAuthorization="$emit('setTFAAuthorization', $event)"
      @afterConfirmAction="$emit('afterConfirmAction', $event)"
      @goBackStep="goBackStep()"
      v-if="currentSlide === '2FA' || !requestPassword"
    />
  </v-dialog>
</template>

<script>
import PasswordChecking from "./PasswordChecking.vue";
import PasswordRecovered from "./PasswordRecovered.vue";
import PasswordRecovering from "./PasswordRecovering.vue";
import TwoFactor from "./TwoFactor.vue";

export default {
  name: "SecurityAuthenticationContainer",

  components: {
    TwoFactor,
    PasswordChecking,
    PasswordRecovering,
    PasswordRecovered,
  },

  data: () => ({
    slides: ["CHECK_PASSWORD"],
  }),

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },

    requestPassword: {
      type: Boolean,
      default: false,
      required: true,
    },

    performingMutation: {
      type: Boolean,
      default: false,
    },

    authenticationErrors: {
      type: Array,
      default: () => [],
    },

    skipTFA: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    requestPassword: {
      immediate: false,
      handler(currentValue) {
        if (!currentValue) {
          this.slides = this.slides.filter(slide => slide !== "CHECK_PASSWORD");
          this.currentSlide = "2FA";
        }
      },
    },
  },

  computed: {
    displayDialog: {
      get() {
        return this.dialog;
      },

      set() {
        this.$emit("closeDialog");
      },
    },

    currentSlide: {
      get() {
        return [...this.slides].pop();
      },

      set(slide) {
        this.slides.push(slide);
      },
    },
  },

  methods: {
    closeDialog() {
      this.displayDialog = false;
      // reset to default value
      this.slides = ["CHECK_PASSWORD"];
    },

    goBackStep() {
      this.slides.pop();
    },

    setPasswordAuthorization(pwd) {
      this.$emit("setPasswordAuthorization", pwd);
      if (!this.skipTFA) {
        this.currentSlide = "2FA";
      } else {
        this.$emit("afterConfirmAction");
      }
    },
  },
};
</script>

<style lang="scss">
.password-form,
.email-form {
  .v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
    > .v-input__control
    > .v-input__slot
    fieldset {
    border-color: #e2e0e0;
  }

  .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 60px !important;
  }

  :not(.file-input).v-text-field--outlined.v-input--is-focused
    > .v-input__control
    > .v-input__slot
    fieldset {
    border: 1px solid #000 !important;
  }

  .theme--light.v-text-field--outlined {
    border-radius: 10px;
  }
}
.security-card-content {
  padding: 40px;
  @media (max-width: 60px) {
    padding: 40px 20px;
  }
}

.cancel-text {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #828282;
  text-align: center;
  margin-top: 40px;
}
.cancel-text:hover {
  cursor: pointer;
}

.step-back-container {
  margin-bottom: 30px;
}

.check-password-title,
.check-email-title {
  font-weight: 600;
  font-size: 22px;
  line-height: 160%;
  color: #333333;
  margin-bottom: 20px;
}

.check-password-text,
.check-email-text {
  font-weight: 500;
  font-size: 16px;
  line-height: 160%;
  color: #333333;
  margin-bottom: 40px !important;
}

.email-text-field,
.password-text-field {
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
}
</style>
